import React, { useState } from 'react';
import { cn } from './Table';

// Miniatura de imagen con fallback. Se usa en insumos, productos y en los selects.
// Si no hay imagen (o falla la carga) muestra las iniciales sobre un fondo neutro:
// nunca un ícono roto ni un hueco, que en una tabla densa se nota mucho.
//
// Tamaños pensados para las tres densidades del grid: sm = fila compacta,
// md = fila normal, lg = ficha/detalle.
const SIZES = {
    sm: 'h-7 w-7 text-[0.6rem] rounded-md',
    md: 'h-10 w-10 text-[0.7rem] rounded-lg',
    lg: 'h-16 w-16 text-sm rounded-xl',
} as const;

export function Thumb({
    src, name, size = 'md', className, onClick,
}: {
    src?: string | null;
    name?: string | null;
    size?: keyof typeof SIZES;
    className?: string;
    onClick?: () => void;
}) {
    const [failed, setFailed] = useState(false);
    const initials = String(name || '?').trim().split(/\s+/).slice(0, 2).map(w => w[0]).join('').toUpperCase();
    const base = cn(
        'shrink-0 overflow-hidden border border-line bg-ground grid place-items-center select-none',
        SIZES[size], onClick && 'cursor-pointer hover:border-brand transition-colors', className,
    );
    if (!src || failed) {
        return <div className={base} onClick={onClick} title={name || undefined}>
            <span className="font-bold text-faint">{initials}</span>
        </div>;
    }
    return (
        <div className={base} onClick={onClick} title={name || undefined}>
            {/* max-w-full + object-cover: la imagen se adapta al contenedor y no desborda la fila */}
            <img src={src} alt={name || ''} loading="lazy" onError={() => setFailed(true)}
                className="h-full w-full max-w-full object-cover" />
        </div>
    );
}
